import { render, staticRenderFns } from "./RegisterHero.vue?vue&type=template&id=2b28aefe&scoped=true&"
import script from "./RegisterHero.vue?vue&type=script&lang=js&"
export * from "./RegisterHero.vue?vue&type=script&lang=js&"
import style0 from "./RegisterHero.vue?vue&type=style&index=0&id=2b28aefe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28aefe",
  null
  
)

export default component.exports